import { Field, Fieldset, Label } from "@headlessui/react";
import { Checkbox } from "antd";
import { Link } from "react-router-dom";
import { cleanPhone } from "../../functions/cleanPhone";
import { Button } from "../tailwind/button";
import { Input } from "../tailwind/input";

export const SignUpForm = ({
  companyCode,
  setCompanyCode,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  setEmail,
  password,
  setPassword,
  phone,
  setPhone,
  errors,
  checked,
  onChange,
  handleSubmit,
  isLoading,
  hideNameFields = false,
  buttonText = "Sign Up",
}) => {
  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <Fieldset>
        <Field>
          <Label>Company Invitation Code</Label>
          <Input
            name="companyCode"
            type="text"
            disabled
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
            {...(errors.companyCode && { "data-invalid": true })}
          />
          {errors.companyCode && (
            <p className="text-red-500 text-xs mt-1">{errors.companyCode}</p>
          )}
        </Field>
        <br />

        {!hideNameFields && (
          <div className="grid grid-cols-2 gap-4 mb-5">
            <Field>
              <Label>First Name</Label>
              <Input
                name="firstName"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                {...(errors.firstName && { "data-invalid": true })}
              />
              {errors.firstName && (
                <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>
              )}
            </Field>
            <Field>
              <Label>Last Name</Label>
              <Input
                name="lastName"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                {...(errors.lastName && { "data-invalid": true })}
              />
              {errors.lastName && (
                <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
              )}
            </Field>
          </div>
        )}

        <Field>
          <Label>Email Address</Label>
          <Input
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            {...(errors.email && { "data-invalid": true })}
          />
          {errors.email && (
            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
          )}
        </Field>
        <br />
        <Field>
          <Label>Password</Label>
          <Input
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            {...(errors.password && { "data-invalid": true })}
          />
          {errors.password && (
            <p className="text-red-500 text-xs mt-1">{errors.password}</p>
          )}
        </Field>
        <br />
        {!hideNameFields && (
          <>
            <Field>
              <Label>Phone Number - to receive test messages</Label>
              <Input
                value={phone}
                maxLength={15}
                onChange={(e) =>
                  setPhone(cleanPhone(e.target.value.replace(/[^0-9]/g, "")))
                }
                autoComplete="off"
              />
              <p
                style={{
                  fontSize: "0.75rem",
                  color: "#999",
                  marginTop: "0.25rem",
                }}
              >
                Please include your country code (e.g., 33601020304)
              </p>
            </Field>
            <br />
          </>
        )}

        <Checkbox checked={checked} onChange={onChange}>
          I accept Simio's{" "}
          <Link
            to="https://help.getsimio.com/fr_FR/conditions-generales"
            target="_blank"
          >
            Terms and Conditions
          </Link>
        </Checkbox>
      </Fieldset>

      <Button
        type="submit"
        color="primaryButton"
        className="flex w-full justify-center bg-yellow font-title font-bold leading-6 "
        loading={isLoading}
        disabled={!checked}
      >
        {buttonText}
      </Button>
    </form>
  );
};
